import { createFileRoute } from "@tanstack/react-router";
import Flags from "common/constants/flags";
import ShowroomIntroPerformanceDebug from "lib/components/debug/ShowroomIntroPerformanceDebug";
import { ShowroomProvider } from "lib/components/showroom2/state/useShowroomState";
import { initializeShowroomWorker } from "lib/hooks/useShowroomWorkerBuilding";
import getPageTitle from "lib/utils/getPageTitle";
import { Helmet as Head } from "react-helmet-async";
import withAuthentication from "../../components/withAuthentication";

function isWorkerModeUrl(href: string): boolean {
  const url = new URL(href, "http://localhost");
  return url.searchParams.get("mode") === "worker";
}

function ShowroomIntroPerformanceDebugPage() {
  return (
    <>
      <Head>
        <title>{getPageTitle("Showroom Intro Performance Debug")}</title>
        <meta name="robots" content="noindex" />
      </Head>

      <ShowroomProvider>
        <ShowroomIntroPerformanceDebug />
      </ShowroomProvider>
    </>
  );
}

export const Route = createFileRoute("/debug/showroom-intro-performance")({
  component: withAuthentication(ShowroomIntroPerformanceDebugPage, { superAdmin: true }),
  loader: ({ location }) => {
    if (Flags.IS_DEV_MODE && isWorkerModeUrl(location.href)) {
      initializeShowroomWorker({ force: true });
    }
  },
  preload: true,
});
